import {
    QUEUE_LIST_RECEIVE_QUEUES,
    QUEUE_LIST_FILTER,
    QUEUE_LIST_FILTER_BY_CURRENT_PERIOD,
    QUEUE_LIST_TOGGLE_QUEUE_COLLAPSE
} from "../config/actions";
import QueueListHelper from '../helpers/queueListHelper';

let defaultState = {
    queues: [],
    availableCurrentPeriods: [],
    currentPeriodsFilter: [],
    searchString: ''
};

const queueListReducer = (state = defaultState, action) => {
    let queues;
    switch (action.type) {
        case QUEUE_LIST_RECEIVE_QUEUES:
            // because rerendering is not working if merging objects?!!!
            /*return {
                queues: action.queues,
                availableCurrentPeriods: action.availableCurrentPeriods,
                currentPeriodsFilter: [],
                searchString: ''
            };*/
            queues = JSON.parse(JSON.stringify(action.queues));
            queues = QueueListHelper.filter(queues, state.searchString, state.currentPeriodsFilter);
            return Object.assign({}, state, {
                queues: queues,
                availableCurrentPeriods: action.availableCurrentPeriods,
            });
        case QUEUE_LIST_FILTER:
            queues = JSON.parse(JSON.stringify(state.queues));
            queues = QueueListHelper.filter(queues, action.searchString, state.currentPeriodsFilter);
            return Object.assign({}, state, {
                queues: queues,
                searchString: action.searchString
            });
        case QUEUE_LIST_FILTER_BY_CURRENT_PERIOD:
            queues = JSON.parse(JSON.stringify(state.queues));
            queues = QueueListHelper.filter(queues, state.searchString, action.periods);
            return Object.assign({}, state, {
                queues: queues,
                currentPeriodsFilter: action.periods
            });
        case QUEUE_LIST_TOGGLE_QUEUE_COLLAPSE:
            queues = JSON.parse(JSON.stringify(state.queues));
            queues = QueueListHelper.toggleCollapse(queues, action.id);
            return Object.assign({}, state, {
                queues: queues
            });
        default:
            return state;
    }
};

export default queueListReducer;